/**
 * Etiquetas en español (España) para los valores del análisis narrativo, que
 * la IA devuelve en inglés (inciting_incident, three_act…). Se traducen SOLO en
 * el display; los valores almacenados siguen en inglés (claves estables).
 */

const TURNING_POINT_LABELS: Record<string, string> = {
  inciting_incident: 'Detonante',
  first_turn: 'Primer giro',
  plot_point_1: 'Primer giro',
  midpoint: 'Punto medio',
  second_turn: 'Segundo giro',
  plot_point_2: 'Segundo giro',
  climax: 'Clímax',
  resolution: 'Resolución',
};

const PARADIGM_LABELS: Record<string, string> = {
  three_act: 'Tres actos',
  five_act: 'Cinco actos',
  non_conventional: 'No convencional',
};

export function turningPointLabel(type?: string | null): string {
  if (!type) return '';
  return TURNING_POINT_LABELS[type] || type.replace(/_/g, ' ');
}

export function paradigmLabel(paradigm?: string | null): string {
  if (!paradigm) return '';
  return PARADIGM_LABELS[paradigm] || paradigm.replace(/_/g, ' ');
}
